import { createReducer, on } from '@ngrx/store';
import {
  loadProjects,
  loadProjectsSuccess,
  loadProjectsFailure,
  addProject,
  addProjectSuccess,
  addProjectFailure,
  deleteProject,
  deleteProjectSuccess,
  deleteProjectFailure,
} from './projects.actions';
import { Project } from '../../interfaces/state/entities/project.interface';
import { ProjectsState } from '../../interfaces/state/reducers/projects-state.interface';

export const initialState: ProjectsState = {
  projects: [],
  loading: false,
  loadingMore: false,
  error: null,
  hasMoreData: false,
  bookmark: null,
  totalCount: null,
  direction: 'Descending',
};

export const projectsReducer = createReducer(
  initialState,
  on(loadProjects, (state, { bookmark, direction }) => ({
    ...state,
    // The page spinner stays up for the opening request and every bookmark page after it.
    loading: true,
    loadingMore: !!bookmark,
    error: null,
    direction,
    ...(bookmark ? {} : { bookmark: null, hasMoreData: false, totalCount: null }),
  })),
  on(loadProjectsSuccess, (state, { projects, hasMoreData, bookmark, totalCount, append, direction }) => ({
    ...state,
    projects: append ? [...state.projects, ...projects] : projects,
    // Drop the spinner only when this response is the end of the list.
    loading: hasMoreData && !!bookmark,
    loadingMore: false,
    hasMoreData,
    bookmark,
    totalCount: totalCount ?? (append ? state.totalCount : null),
    direction,
  })),
  on(loadProjectsFailure, (state, { error, append }) => ({
    ...state,
    loading: false,
    loadingMore: false,
    error: append ? state.error : error,
    // A failed later page should not leave the pager waiting for a bookmark that will not arrive.
    ...(append ? { hasMoreData: false, bookmark: null } : {}),
  })),
  on(addProject, (state) => ({ ...state, loading: true, error: null })),
  on(addProjectSuccess, (state, { project }) => ({
    ...state,
    projects: [...state.projects, project],
    loading: false,
  })),
  on(addProjectFailure, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(deleteProject, (state) => ({ ...state, loading: true, error: null })),
  on(deleteProjectSuccess, (state, { id }) => ({
    ...state,
    projects: state.projects.filter((p) => p.id !== id),
    loading: false,
  })),
  on(deleteProjectFailure, (state) => ({
    ...state,
    loading: false,
    error: null,
  }))
);
